<template>
  <!-- 微信群设置-群列表-编辑 -->
  <el-dialog
    title="微信群编辑"
    :visible.sync="show"
    :before-close="closeDialog"
    width="80%"
  >
    <div class="container1 weixin">
      <div class="handle-box-search">
        <div class="handle-box">
          <el-row class="head-search">
            <el-col :span="14">
              <span class="title">微信号:</span>
              <el-input
                v-model="search_data_children.user_id"
                class="handle-input mr10"
                placeholder="请输入微信号"
                @keyup.enter.native="searchUserLists"
              >
              </el-input>
            </el-col>

            <el-col :span="10">
              <span class="title">昵称:</span>
              <el-input
                v-model="search_data_children.name"
                class="handle-input mr10"
                placeholder="请输入昵称"
                @keyup.enter.native="searchUserLists"
              >
              </el-input>
            </el-col>
          </el-row>
        </div>
        <el-button type="primary" @click="searchUserLists" size="medium"
          >搜索</el-button
        >
        <el-button @click="refresh" size="medium">刷新</el-button>
        <el-button @click="closeDialog" size="medium">关闭</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column label="聊天室名称" prop="chat_room_name">
        </el-table-column>

        <el-table-column label="群名" prop="NickName"> </el-table-column>

        <el-table-column label="微信号" prop="user_id"> </el-table-column>
        <el-table-column label="昵称" prop="name"> </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <div>
              {{ scope.row.status == "0" ? "拉黑" : "正常" }}
            </div>
          </template>
        </el-table-column>
        <!-- 列表开关列表switch开 0拉黑，1正常 -->
        <!-- <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-switch
              :class="{
                'pri-switch-close': scope.row.status == '0',
                'pri-switch-open': scope.row.status == '1',
              }"
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              active-text="正常"
              inactive-text="拉黑"
              @change="updateUserStatusSub(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" prop="state" min-width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="scope.row.status == '1' ? 'danger' : 'primary'"
              @click="updateUserStatusSub(scope.row)"
            >
              {{ scope.row.status == "1" ? "拉黑" : "正常" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- element ui 原生分页组件 -->
      <div class="pagination">
        <el-pagination
        v-if="result_data.count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search_data_children.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search_data_children.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result_data.count"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
var _this;


export default {
  props: {
    isShow: Boolean,
    data: "",
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;


      this.search_data_children.chat_room_name = this.data

      this.getUserLists();

      // _this.searchUserLists();
    },
  },

  data() {
    return {
      show: false,

      loading: false,

      // 存放表格数据
      tableData: [],


      //获取用户列表的数据
      search_data_children: {
        page: 1,
        limit: 10,
        user_id: "",
        name: "",
        chat_room_name:""  
      },
      result_data: {},
      search_rules: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },

  methods: {
    // 拉黑按钮
    updateUserStatusSub(e) {

      let propsData = {
        user_id: e.user_id,
        chat_room_name: e.chat_room_name,
        status: e.status == "1" ? "0" : "1",
      };

      _this
        .$post("/machine/updateUserStatusSub", propsData)
        .then((res) => {
          this.$message.success(res.msg);
          _this.searchUserLists();
        })
        .catch((err) => {});
    },
   
    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.loading = false;


      _this.tableData = [];
      _this.result_data = {};

      _this.search_data_children = {
        page: 1,
        limit: 10,
        user_id: "",
        name: "",
        chat_room_name:""
      };
    },

    // 刷新按钮
    refresh() {
      this.$router.go(0);
    },
    // 搜索
    searchUserLists() {
      _this.search_data_children.page = 1;

      _this.getUserLists();
    },
    // 初始化列表
    getUserLists() {
      _this.loading = true;

      _this
        .$post(
          "/machine/getUserLists",
          _this.search_data_children,
          _this.search_rules
        )
        .then((res) => {
          _this.loading = false;

          _this.tableData = res.data.data;
          _this.result_data = res.data;
        })
        .catch((err) => {
          _this.loading = false;

          this.$message.error(res.msg);
        });
    },
    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data_children.limit = val;

      //初始化列表
      _this.getUserLists();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data_children.page = val;

      //初始化列表
      _this.getUserLists();
    },
    //翻页组件的回调
    pages_function() {
      //初始化列表
      _this.getUserLists();
    },
  },
};
</script>
<style scoped>
.search-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
  margin-left: 10px;
  margin-top: 10px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.search-box {
  display: flex;
}

.searchBox {
  margin: 10px;
  padding: 30px 0;
  border-radius: 15px;
  background-color: #f5f7fa !important;
  border: 1px solid #dcdfe6;
}

.title {
  display: inline-block !important;
  width: 80px !important;
  text-align: right !important;
  padding-right: 5px !important;
  box-sizing: border-box !important;
  background-color: transparent !important;
  color: #000;
  font-size: 14px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.btn {
  margin-left: 10px;
}
</style>
<style>
.weixin .pri-switch-close .el-switch__core {
  width: 50px !important;
}
.weixin .pri-switch-close .el-switch__core::after {
  content: "拉黑";
  font-size: 8px;
  text-align: center;
  line-height: 16px;
  color: #ff4949;
}

.weixin .pri-switch-open .el-switch__core::after {
  content: "正常";
  font-size: 8px;
  text-align: center;
  line-height: 16px;
  color: #13ce66;
}
</style>